import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReveloLayout from "../Component/ReveloLayout";
import NautikaSeatOverlayAnchored from "./NautikaSeatOverlay";

export default function FerrySeatSelection() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [chosen, setChosen] = useState({});
  const [activeTab, setActiveTab] = useState("B"); // default: Royal

  if (!state) {
    return (
      <ReveloLayout header={1} footer={1}>
        <p>No sailing selected.</p>
      </ReveloLayout>
    );
  }

  const { sailing, selectedClass, search } = state;

  const selectedCount = (chosen?.B?.length || 0) + (chosen?.P?.length || 0);
  const canContinue = selectedCount === (search?.passengers || 1);

  const handleContinue = () => {
    navigate("/passengerdetails", {
      state: {
        sailing,
        selectedClass,
        chosenSeats: chosen,
        search,
      },
    });
  };

  return (
    <ReveloLayout>
      <section className="pt-120 container">
        <h3>
          {sailing.ferryName} • {selectedClass.class}
        </h3>

        <p>
          {search.source} → {search.destination} &nbsp; | &nbsp;
          {sailing.departureTime} → {sailing.arrivalTime}
        </p>


        {/* Tabs (only visible on small/medium screens) */}
        <div className="tab-container">
          {sailing.seatMaps?.bClass && (
            <button
              className={`tab-btn ${activeTab === "B" ? "active" : ""}`}
              onClick={() => setActiveTab("B")}
            >
              Royal Class
            </button>
          )}
          {sailing.seatMaps?.pClass && (
            <button
              className={`tab-btn ${activeTab === "P" ? "active" : ""}`}
              onClick={() => setActiveTab("P")}
            >
              Luxury Class
            </button>
          )}
        </div>

        {/* Seat maps */}
        <div className="seat-maps">
          {/* Side-by-side on large screens */}
          <div className="seat-column">
            {sailing.seatMaps?.bClass && (
              <NautikaSeatOverlayAnchored
                seatMap={sailing.seatMaps.bClass}
                classCode="B"
                passengers={search.passengers}
                bgUrl="https://andaman-makeholiday.s3.ap-south-1.amazonaws.com/nautika-royal.webp"
                onChange={(seats) => {
                  setChosen((prev) => ({ ...prev, B: seats }));
                }}
                seatScale={1}
              />
            )}
          </div>

          <div className="seat-column">
            {sailing.seatMaps?.pClass && (
              <NautikaSeatOverlayAnchored
                seatMap={sailing.seatMaps.pClass}
                classCode="P"
                passengers={search.passengers}
                bgUrl="https://andaman-makeholiday.s3.ap-south-1.amazonaws.com/nautika-luxury.webp"
                onChange={(seats) => {
                  setChosen((prev) => ({ ...prev, P: seats }));
                }}
                seatScale={1}
              />
            )}
          </div>
        </div>

        {/* Tab content (only visible on small/medium screens) */}
        <div className="tab-content">
          {activeTab === "B" && sailing.seatMaps?.bClass && (
            <NautikaSeatOverlayAnchored
              seatMap={sailing.seatMaps.bClass}
              classCode="B"
              passengers={search.passengers}
              bgUrl="https://andaman-makeholiday.s3.ap-south-1.amazonaws.com/nautika-royal.webp"
              onChange={(seats) => {
                setChosen((prev) => ({ ...prev, B: seats }));
              }}
              seatScale={1}
            />
          )}
          {activeTab === "P" && sailing.seatMaps?.pClass && (
            <NautikaSeatOverlayAnchored
              seatMap={sailing.seatMaps.pClass}
              classCode="P"
              passengers={search.passengers}
              bgUrl="https://andaman-makeholiday.s3.ap-south-1.amazonaws.com/nautika-luxury.webp"
              onChange={(seats) => {
                setChosen((prev) => ({ ...prev, P: seats }));
              }}
              seatScale={1}
            />
          )}
        </div>

        <div style={{ margin: 20, textAlign: "center" }}>
          <button
            className="theme-btn style-one w-25 h-100 py-10"
            disabled={!canContinue}
            onClick={handleContinue}
          >
            Continue ({selectedCount}/{search?.passengers || 1})
          </button>
        </div>
      </section>

      {/* Responsive CSS */}
      <style>{`
        .seat-maps {
          display: flex;
          gap: 20px;
        }
        .seat-column {
          flex: 1;
        }

        /* Hide tabs & tab content on large screens */
        .tab-container,
        .tab-content {
          display: none;
        }

        /* On small/medium screens, show tabs and tab content, hide side-by-side view */
        @media (max-width: 992px) {
          .seat-maps {
            display: none;
          }
          .tab-container {
            display: flex;
            border-bottom: 1px solid #ddd;
            margin-bottom: 15px;
          }
          .tab-btn {
            flex: 1;
            padding: 10px;
            border: none;
            background: #f8f9fa;
             color: #000;
            cursor: pointer;
            font-weight: 600;
          }
          .tab-btn.active {
            background: #fff;
            border-bottom: 3px solid #007bff;
            color: #007bff;
          }
          .tab-content {
            display: block;
          }
        }
      `}</style>
    </ReveloLayout>
  );
}
